import { z } from "zod";

export const EditFeesFormSchema = z.object({
  insuranceFee: z.number().min(0).nullable(),
  selfPayFee: z.number().min(0).nullable(),
  isActive: z.boolean(),
});

export type EditFeesFormType = z.infer<typeof EditFeesFormSchema>;
